var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fragment",
    [
      _c(
        "article",
        { staticClass: "mt-2" },
        [
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.creating,
                  expression: "creating",
                },
              ],
              staticClass: "title",
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("lists.addContactsToTheList")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("radio-section", {
            attrs: {
              name: "import-selection-type",
              "class-name": "required",
              options: _vm.selectOptions,
              "full-width": true,
            },
            model: {
              value: _vm.manually,
              callback: function ($$v) {
                _vm.manually = $$v
              },
              expression: "manually",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: {
            name: "custom-classes-transition",
            "enter-active-class": "animated fadeIn",
          },
        },
        [
          _c(
            "article",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.manually === false,
                  expression: "manually === false",
                },
              ],
              staticClass: "fe-section-toggler-hide",
              attrs: { id: "import-contacts-article" },
            },
            [
              _c("div", { staticClass: "row w-100 no-gutters flex-column" }, [
                _c("p", { staticClass: "text-gray bold mb-0" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("lists.importOptions")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "small text-primary mb-0 mr-2 clickable",
                    attrs: {
                      "data-toggle": "modal",
                      "data-target": "#csv-modal",
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("global.phrases.howDoICreateACsvFile")) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row w-100 no-gutters mt-3" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    { staticClass: "pretty required p-icon p-smooth p-bigger" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.applications,
                            expression: "applications",
                          },
                        ],
                        staticClass: "checkbox one-checkbox",
                        attrs: {
                          id: "applications-check",
                          required: "",
                          "data-parsley-multiple": "contacts-choice",
                          name: "applications",
                          type: "checkbox",
                          value: "true",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.applications)
                            ? _vm._i(_vm.applications, "true") > -1
                            : _vm.applications,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.applications,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "true",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.applications = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.applications = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.applications = $$c
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "state p-primary" }, [
                        _c("i", { staticClass: "icon material-icons" }, [
                          _vm._v("done"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "text-light-gray clickable",
                            attrs: { for: "applications-check" },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("lists.importFromApplications")) +
                                "\n              "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "row w-100 no-gutters justify-content-center mt-1",
                },
                [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      {
                        staticClass: "pretty required p-icon p-smooth p-bigger",
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.clientProfiles,
                              expression: "clientProfiles",
                            },
                          ],
                          staticClass: "checkbox one-checkbox",
                          attrs: {
                            id: "client-profiles-check",
                            name: "clientProfiles",
                            "data-parsley-multiple": "contacts-choice",
                            type: "checkbox",
                            value: "true",
                          },
                          domProps: {
                            checked: Array.isArray(_vm.clientProfiles)
                              ? _vm._i(_vm.clientProfiles, "true") > -1
                              : _vm.clientProfiles,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.clientProfiles,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "true",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.clientProfiles = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.clientProfiles = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.clientProfiles = $$c
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "state p-primary" }, [
                          _c("i", { staticClass: "icon material-icons" }, [
                            _vm._v("done"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "text-light-gray clickable",
                              attrs: { for: "client-profiles-check" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("lists.importFromClientProfiles")
                                ) + "\n              "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "row w-100 no-gutters justify-content-center mt-1",
                },
                [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "pretty required p-icon p-smooth p-bigger fe-section-toggler",
                        attrs: {
                          "data-fe-target": "#input-row",
                          "data-fe-action": "auto",
                        },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.importedCsvOption,
                              expression: "importedCsvOption",
                            },
                          ],
                          staticClass: "checkbox one-checkbox",
                          attrs: {
                            id: "imported-check",
                            name: "imported",
                            "data-parsley-multiple": "contacts-choice",
                            type: "checkbox",
                            value: "true",
                          },
                          domProps: {
                            checked: Array.isArray(_vm.importedCsvOption)
                              ? _vm._i(_vm.importedCsvOption, "true") > -1
                              : _vm.importedCsvOption,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.importedCsvOption,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "true",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.importedCsvOption = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.importedCsvOption = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.importedCsvOption = $$c
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "state p-primary" }, [
                          _c("i", { staticClass: "icon material-icons" }, [
                            _vm._v("done"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "text-light-gray clickable",
                              attrs: { for: "imported-check" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("lists.importFromCsv")) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "row w-100 no-gutters justify-content-center mt-1",
                },
                [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      {
                        staticClass: "pretty required p-icon p-smooth p-bigger",
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.referrerList,
                              expression: "referrerList",
                            },
                          ],
                          staticClass: "checkbox one-checkbox",
                          attrs: {
                            id: "referrers-check",
                            name: "referrerList",
                            "data-parsley-multiple": "contacts-choice",
                            type: "checkbox",
                            value: "true",
                          },
                          domProps: {
                            checked: Array.isArray(_vm.referrerList)
                              ? _vm._i(_vm.referrerList, "true") > -1
                              : _vm.referrerList,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.referrerList,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "true",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.referrerList = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.referrerList = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.referrerList = $$c
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "state p-primary" }, [
                          _c("i", { staticClass: "icon material-icons" }, [
                            _vm._v("done"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "text-light-gray clickable",
                              attrs: { for: "referrers-check" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "lists.importFromReferrersSlashParticipants"
                                  )
                                ) + "\n              "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.clientProfiles || _vm.applications
                ? _c(
                    "div",
                    {
                      staticClass:
                        "row w-100 no-gutters justify-content-center mt-3",
                    },
                    [
                      _c("div", { staticClass: "state text-primary col-12" }, [
                        _c("p", { staticClass: "mb-0 text-primary bold" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("lists.filterImportOption")) +
                              "\n          "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mt-2 col-12" },
                        [
                          _c("datepicker-input", {
                            attrs: {
                              value: { start: _vm.startDate, end: _vm.endDate },
                              "is-range": "",
                            },
                            on: { change: _vm.handleChangeRange },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "start-date-input",
                                  fn: function (ref) {
                                    var inputValue = ref.inputValue
                                    var inputEvents = ref.inputEvents
                                    return [
                                      _c(
                                        "material-input",
                                        {
                                          attrs: {
                                            value: inputValue.start,
                                            label: _vm.$t(
                                              "global.doorr.startDate"
                                            ),
                                          },
                                        },
                                        [
                                          _c(
                                            "input",
                                            _vm._g(
                                              {
                                                directives: [
                                                  {
                                                    name: "mask",
                                                    rawName: "v-mask",
                                                    value: {
                                                      mask: "9999-99-99",
                                                      placeholder: "YYYY-MM-DD",
                                                      alias: "date",
                                                      greedy: false,
                                                      showMaskOnHover: false,
                                                    },
                                                    expression:
                                                      "{\n                    mask: '9999-99-99',\n                    placeholder: 'YYYY-MM-DD',\n                    alias: 'date',\n                    greedy: false,\n                    showMaskOnHover: false\n                  }",
                                                  },
                                                ],
                                                staticClass:
                                                  "material-input form-control form",
                                                attrs: { autocomplete: "off" },
                                                domProps: {
                                                  value: inputValue.start,
                                                },
                                              },
                                              inputEvents.start
                                            )
                                          ),
                                          _vm._v(" "),
                                          _c("icon", {
                                            attrs: {
                                              name: "calendar",
                                              "icon-class":
                                                "icon fe-dp-icon text-primary",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "end-date-input",
                                  fn: function (ref) {
                                    var inputValue = ref.inputValue
                                    var inputEvents = ref.inputEvents
                                    return [
                                      _c(
                                        "material-input",
                                        {
                                          attrs: {
                                            value: inputValue.end,
                                            label: _vm.$t(
                                              "global.doorr.endDate"
                                            ),
                                          },
                                        },
                                        [
                                          _c(
                                            "input",
                                            _vm._g(
                                              {
                                                directives: [
                                                  {
                                                    name: "mask",
                                                    rawName: "v-mask",
                                                    value: {
                                                      mask: "9999-99-99",
                                                      placeholder: "YYYY-MM-DD",
                                                      alias: "date",
                                                      greedy: false,
                                                      showMaskOnHover: false,
                                                    },
                                                    expression:
                                                      "{\n                    mask: '9999-99-99',\n                    placeholder: 'YYYY-MM-DD',\n                    alias: 'date',\n                    greedy: false,\n                    showMaskOnHover: false\n                  }",
                                                  },
                                                ],
                                                staticClass:
                                                  "material-input form-control form",
                                                attrs: {
                                                  label: "End Date",
                                                  autocomplete: "off",
                                                },
                                                domProps: {
                                                  value: inputValue.end,
                                                },
                                              },
                                              inputEvents.end
                                            )
                                          ),
                                          _vm._v(" "),
                                          _c("icon", {
                                            attrs: {
                                              name: "calendar",
                                              "icon-class":
                                                "icon fe-dp-icon text-primary",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              941939821
                            ),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12" }, [
                        _c("p", { staticClass: "text-primary bold" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("lists.includeCoapplicants")) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "pretty required p-icon p-smooth p-bigger",
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.withCoapps,
                                  expression: "withCoapps",
                                },
                              ],
                              staticClass: "checkbox one-checkbox",
                              attrs: {
                                id: "coapps-check",
                                name: "coapps",
                                type: "checkbox",
                              },
                              domProps: {
                                value: _vm.withCoapps,
                                checked: Array.isArray(_vm.withCoapps)
                                  ? _vm._i(_vm.withCoapps, _vm.withCoapps) > -1
                                  : _vm.withCoapps,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.withCoapps,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = _vm.withCoapps,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.withCoapps = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.withCoapps = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.withCoapps = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "state p-primary" }, [
                              _c("i", { staticClass: "icon material-icons" }, [
                                _vm._v("done"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "text-light-gray clickable",
                                  attrs: { for: "coapps-check" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "global.actions.includeCoapplicants"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isBroker
                ? _c(
                    "transition",
                    {
                      attrs: {
                        name: "custom-classes-transition",
                        "enter-active-class": "animated fadeIn",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.clientProfiles ||
                                _vm.applications ||
                                _vm.referrerList,
                              expression:
                                "clientProfiles || applications || referrerList",
                            },
                          ],
                          staticClass: "mt-3",
                        },
                        [
                          _c("p", { staticClass: "mb-0 text-primary bold" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("lists.importFromOtherAgents")) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("agents-select", {
                            ref: "agentSelect",
                            attrs: { "ignore-current-agent": "" },
                            on: { change: _vm.handleChange },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "transition",
                {
                  attrs: {
                    name: "custom-classes-transition",
                    "enter-active-class": "animated fadeIn",
                  },
                },
                [
                  _c(
                    "article",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.importedCsvOption,
                          expression: "importedCsvOption",
                        },
                      ],
                      staticClass:
                        "row w-100 no-gutters justify-content-center mt-1",
                      attrs: { id: "input-row" },
                    },
                    [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-sm btn-moregage btn-primary mb-1 upload-resp-btn bold select-document",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.$refs.fileInput.click()
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-upload pr-2",
                              attrs: { "aria-hidden": "true" },
                            }),
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.file
                                    ? _vm.$tc("global.actions.selectAFile", 1, {
                                        count: 1,
                                      })
                                    : _vm.$tc("global.actions.selectAFile", 0)
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          ref: "fileInput",
                          staticClass: "d-none",
                          attrs: {
                            id: "file-input",
                            required: "",
                            type: "file",
                            accept: ".csv,text/plain",
                          },
                          on: { change: _vm.handleFileChange },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "d-none",
                            attrs: { for: "file-input" },
                          },
                          [_vm._v(_vm._s(_vm.$tc("global.words.file", 1)))]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: {
            name: "custom-classes-transition",
            "enter-active-class": "animated fadeIn",
          },
        },
        [
          _c(
            "article",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.manually,
                  expression: "manually",
                },
              ],
              staticClass: "fe-section-toggler-hide",
              attrs: { id: "add-contacts-article" },
            },
            [
              _c("div", { staticClass: "row w-100 no-gutters" }, [
                _c(
                  "p",
                  { staticClass: "text-gray bold" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("lists.enterEmails")) +
                        "\n          "
                    ),
                    _c("input-required-indicator"),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "row w-100 no-gutters justify-content-center mt-1",
                },
                [
                  _c("div", { staticClass: "col-12" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.emailList,
                          expression: "emailList",
                        },
                      ],
                      staticClass: "form-control email-multiple",
                      attrs: {
                        id: "email",
                        "data-skip-falsy": "true",
                        required: "",
                        rows: "3",
                        name: "importedList",
                      },
                      domProps: { value: _vm.emailList },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.emailList = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "d-none", attrs: { for: "email" } },
                      [_vm._v(_vm._s(_vm.$tc("global.words.email", 2)))]
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: { id: "csv-modal", tabindex: "-1", role: "dialog" },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog", attrs: { role: "document" } },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("lists.importOptions")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "modal",
                        "aria-label": "Close",
                      },
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×"),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("p", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("lists.importCsv.title")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", { staticClass: "bold" }, [_vm._v("1.")]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("lists.importCsv.step1")) +
                        "\n            "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", { staticClass: "bold" }, [_vm._v("2.")]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("lists.importCsv.step2")) +
                        "\n            "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", { staticClass: "bold" }, [_vm._v("3.")]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("lists.importCsv.step3")) +
                        "\n            "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", { staticClass: "bold" }, [_vm._v("4.")]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("lists.importCsv.step4")) +
                        "\n            "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", { staticClass: "bold" }, [_vm._v("5.")]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("lists.importCsv.step5")) +
                        "\n            "
                    ),
                    _c("br"),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("lists.importCsv.onceSaved")) +
                        " "
                    ),
                    _c("br"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex justify-content-center" }, [
                    _c("p", { staticClass: "p-3 csv" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("lists.importCsv.exampleHeaders"))
                      ),
                      _c("br"),
                      _vm._v("\n              John, Smith, john@company.com "),
                      _c("br"),
                      _vm._v(
                        "\n              Jane, Doe, jane@company.com\n            "
                      ),
                    ]),
                  ]),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("lists.importCsv.commasSeparation")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-white",
                      attrs: { type: "button", "data-dismiss": "modal" },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("global.words.close")) +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }